import React from 'react';
import Fancybox from "../components/Fancybox";
import UbicacionCompoent from "../components/UbicacionComponent";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PageTransition from "../components/PageTansition";

const Interiores = () => {

    const galeriaSlide = {
        arrows: false,
        dots: true,
        infinite: false,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    const galeriaSlide2 = {
        arrows: false,
        dots: true,
        infinite: false,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const galeriaSlide3 = {
        arrows: false,
        dots: true,
        infinite: false,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    return (
        <div className="page interiores">

            {/* Version de telefonos */}
            <section className="contenido">
                <div className="arriba">
                    <p className="texto"> REVISA CADA ESPACIO <span>DE <strong>NUESTRO PILOTO</strong></span></p>
                    <p className="big">EXPLORA</p>
                </div>
                <Fancybox>
                    <div className="imagenes">
                        <div className="imagen">
                            <a href="/images/interiores/galeria_1_zoom_celular.png" data-fancybox="galleria" data-caption="Galeria 1">
                                <img
                                    src={"/images/interiores/galeria_1_celular.png"}
                                    alt="Galeria 1"
                                    style={{ width: "154px", height: "148px" }}

                                />
                            </a>
                        </div>
                        <div className="imagen">
                            <a href="/images/interiores/galeria_2_zoom_celular.png" data-fancybox="galleria" data-caption="Galeria 2">
                                <img
                                    src={"/images/interiores/galeria_2_celular.png"}
                                    alt="Galeria 2"
                                    style={{ width: "154px", height: "148px" }}
                                />
                            </a>
                        </div>
                        <div className="imagen">
                            <a href="/images/interiores/galeria_3_zoom_celular.png" data-fancybox="galleria" data-caption="Galeria 3">
                                <img
                                    src={"/images/interiores/galeria_3_celular.png"}
                                    alt="Galeria 3"
                                    style={{ width: "154px", height: "148px" }}
                                />
                            </a>
                        </div>
                        <div className="imagen">
                            <a href="/images/interiores/galeria_4_zoom_celular.png" data-fancybox="galleria" data-caption="Galeria 4">
                                <img
                                    src={"/images/interiores/galeria_4_celular.png"}
                                    alt="Galeria 4"
                                    style={{ width: "154px", height: "148px" }}
                                />
                            </a>
                        </div>
                        <div className="imagen">
                            <a href="/images/interiores/galeria_5_zoom_celular.png" data-fancybox="galleria" data-caption="Galeria 5">
                                <img
                                    src={"/images/interiores/galeria_5_celular.png"}
                                    alt="Galeria 5"
                                    style={{ width: "154px", height: "148px" }}
                                />
                            </a>
                        </div>
                        <div className="imagen">
                            <a href="/images/interiores/galeria_6_zoom_celular.png" data-fancybox="galleria" data-caption="Galeria 6">
                                <img
                                    src={"/images/interiores/galeria_6_celular.png"}
                                    alt="Galeria 6"
                                    style={{ width: "154px", height: "148px" }}
                                />
                            </a>
                        </div>
                        <div className="imagen">
                            <a href="/images/interiores/galeria_7_zoom_celular.png" data-fancybox="galleria" data-caption="Galeria 7">
                                <img
                                    src={"/images/interiores/galeria_7_celular.png"}
                                    alt="Galeria 7"
                                    style={{ width: "154px", height: "148px" }}
                                />
                            </a>
                        </div>
                        <div className="imagen">
                            <a href="/images/interiores/galeria_8_celular.png" data-fancybox="galleria" data-caption="Galeria 8">
                                <img
                                    src={"/images/interiores/galeria_8_zoom_celular.png"}
                                    alt="Galeria 8"
                                    style={{ width: "154px", height: "148px" }}
                                />
                            </a>
                        </div>
                    </div>
                </Fancybox>
            </section>

            {/* Version escritorio */}
            <section id="galeria">
                <div className="arriba">
                    <div className="titulo"><p>EXPLORA</p></div>
                    <div className="texto"><p>REVISA CADA ESPACIO <span>DE <strong>NUESTRO PILOTO</strong></span></p></div>

                    <div className="note">
                        <p className="texto-note"> TE INVITAMOS A <span>DESCUBRIR NUESTRAS FINAS </span>TERMINACIONES Y AMPLIOS
                            <br />
                            <br />
                            <span>ESPACIOS EN NUESTROS </span>DESPARTAMENTOS</p>
                    </div>
                </div>

                <div className="in">
                    <div className="galeria-arriba">
                        <div className="slide">
                            <Fancybox>
                                <Slider {...galeriaSlide}>
                                    <div className="item">
                                        <a href="/images/interiores/galeria_1_slide_1_escritorio.png" data-fancybox="galeria-1" data-caption="Galeria 2">
                                            <div className="tablet">
                                                <img
                                                    src={"/images/interiores/galeria_1_slide_1_tablet.png"}
                                                    alt="comedor"
                                                    style={{ width: "401px", height: "267px" }}

                                                />
                                            </div>
                                            <div className="note">
                                                <img
                                                    src={"/images/interiores/galeria_1_slide_1_escritorio.png"}
                                                    alt="comedor"
                                                    style={{ width: "841px", height: "494px" }}
                                                />
                                            </div>
                                        </a>
                                    </div>
                                    <div className="item">
                                        <a href="/images/interiores/galeria_1_slide_2_escritorio.png" data-fancybox="galeria-1" data-caption="Galeria 2">
                                            <div className="tablet">
                                                <img
                                                    src={"/images/interiores/galeria_1_slide_2_tablet.png"}
                                                    alt="baño"
                                                    style={{ width: "401px", height: "267px" }}
                                                />
                                            </div>
                                            <div className="note">
                                                <img
                                                    src={"/images/interiores/galeria_1_slide_2_escritorio.png"}
                                                    alt="baño"
                                                    style={{ width: "841px", height: "494px" }}
                                                />
                                            </div>
                                        </a>
                                    </div>
                                    <div className="item">
                                        <a href="/images/interiores/galeria_1_slide_3_escritorio.png" data-fancybox="galeria-1" data-caption="Galeria 2">
                                            <div className="tablet">
                                                <img
                                                    src={"/images/interiores/galeria_1_slide_3_tablet.png"}
                                                    alt="dormitorio"
                                                    style={{ width: "401px", height: "267px" }}

                                                />
                                            </div>
                                            <div className="note">
                                                <img
                                                    src={"/images/interiores/galeria_1_slide_3_escritorio.png"}
                                                    alt="dormitorio"
                                                    style={{ width: "841px", height: "494px" }}

                                                />
                                            </div>
                                        </a>
                                    </div>
                                </Slider>
                            </Fancybox>
                        </div>

                        <div className="imagen-arriba-1">
                            <Fancybox>
                                <a href="/images/interiores/galeria_2_escritorio.png" data-fancybox="galeria-1" data-caption="Galeria 2">
                                    <div className="tablet">
                                        <img
                                            src={"/images/interiores/galeria_2_tablet.png"}
                                            alt="dormitorio"
                                            style={{ width: "194px", height: "129px" }}
                                        />
                                    </div>
                                    <div className="note">
                                        <img
                                            src={"/images/interiores/galeria_2_escritorio.png"}
                                            alt="dormitorio"
                                            style={{ width: "453px", height: "239px" }}
                                        />
                                    </div>
                                </a>
                            </Fancybox>
                        </div>

                        <div className="imagen-arriba-2">
                            <Fancybox>
                                <a href="/images/interiores/galeria_3_escritorio.png" data-fancybox="galeria-1" data-caption="Galeria 2">
                                    <div className="tablet">
                                        <img
                                            src={"/images/interiores/galeria_3_tablet.png"}
                                            alt="living"
                                            style={{ width: "194px", height: "129px" }}
                                        />
                                    </div>
                                    <div className="note">
                                        <img
                                            src={"/images/interiores/galeria_3_escritorio.png"}
                                            alt="living"
                                            style={{ width: "453px", height: "239px" }}
                                        />
                                    </div>
                                </a>
                            </Fancybox>
                        </div>
                    </div>

                    <div className="galeria-medio">
                        <div className="slide-2">
                            <Fancybox>
                                <Slider {...galeriaSlide2}>
                                    <div className="item">
                                        <a href="/images/interiores/galeria_5_slide_1_escritorio.png" data-fancybox="galeria-2" data-caption="Galeria 3">
                                            <div className="tablet">
                                                <img
                                                    src={"/images/interiores/galeria_7_slide_1_tablet.png"}
                                                    alt="lindo lugar para un cafe"
                                                    style={{ width: "294px", height: "600px" }}
                                                />
                                            </div>
                                            <div className="note">
                                                <img
                                                    src={"/images/interiores/galeria_5_slide_1_escritorio.png"}
                                                    alt="lindo lugar para un cafe"
                                                    style={{ width: "647px", height: "1290px" }}
                                                />
                                            </div>
                                        </a>
                                    </div>

                                    <div className="item">
                                        <a href="/images/interiores/galeria_7_slide_2_tablet.png" data-fancybox="galeria-2" data-caption="Galeria 3">
                                            <div className="tablet">
                                                <img
                                                    src={"/images/interiores/galeria_7_slide_2_tablet.png"}
                                                    alt="baño"
                                                    style={{ width: "294px", height: "600px" }}
                                                />
                                            </div>
                                            <div className="note">
                                                <img
                                                    src={"/images/interiores/galeria_5_slide_2_escritorio.png"}
                                                    alt="baño"
                                                    style={{ width: "647px", height: "1290px" }}
                                                />
                                            </div>
                                        </a>
                                    </div>

                                    <div className="item">
                                        <a href="/images/interiores/galeria_5_slide_3_escritorio.png" data-fancybox="galeria-2" data-caption="Galeria 3">
                                            <div className="tablet">
                                                <img
                                                    src={"/images/interiores/galeria_7_slide_3_tablet.png"}
                                                    alt="seguridad"
                                                    style={{ width: "294px", height: "600px" }}
                                                    width={294}
                                                    height={600}
                                                />
                                            </div>
                                            <div className="note">
                                                <img
                                                    src={"/images/interiores/galeria_5_slide_3_escritorio.png"}
                                                    alt="seguridad"
                                                    style={{ width: "647px", height: "1290px" }}
                                                />
                                            </div>
                                        </a>
                                    </div>

                                </Slider>
                            </Fancybox>
                        </div>

                        <div className="imagen-medio-1">
                            <Fancybox>
                                <a href="/images/interiores/galeria_4_escritorio.png" data-fancybox="galeria-2" data-caption="Galeria 2">
                                    <div className="tablet">
                                        <img
                                            src={"/images/interiores/galeria_4_tablet.png"}
                                            alt="living"
                                            style={{ width: "293px", height: "195px" }}
                                        />
                                    </div>
                                    <div className="note">
                                        <img
                                            src={"/images/interiores/galeria_4_escritorio.png"}
                                            alt="living"
                                            style={{ width: "650px", height: "410px" }}
                                        />
                                    </div>
                                </a>
                            </Fancybox>
                        </div>

                        <div className="imagen-medio-2">
                            <Fancybox>
                                <a href="/images/interiores/galeria_6_escritorio.png" data-fancybox="galeria-2" data-caption="Galeria 2">
                                    <div className="tablet">
                                        <img
                                            src={"/images/interiores/galeria_5_tablet.png"}
                                            alt="baño"
                                            style={{ width: "293px", height: "195px" }}
                                        />
                                    </div>
                                    <div className="note">
                                        <img
                                            src={"/images/interiores/galeria_6_escritorio.png"}
                                            alt="baño"
                                            style={{ width: "650px", height: "410px" }}
                                        />
                                    </div>
                                </a>
                            </Fancybox>
                        </div>
                        <div className="imagen-medio-3">
                            <Fancybox>
                                <a href="/images/interiores/galeria_7_escritorio.png" data-fancybox="galeria-2" data-caption="Galeria 2">
                                    <div className="tablet">
                                        <img
                                            src={"/images/interiores/galeria_6_tablet.png"}
                                            alt="dormitorio"
                                            style={{ width: "293px", height: "195px" }}
                                        />
                                    </div>
                                    <div className="note">
                                        <img
                                            src={"/images/interiores/galeria_7_escritorio.png"}
                                            alt="dormitorio"
                                            style={{ width: "650px", height: "410px" }}
                                        />
                                    </div>
                                </a>
                            </Fancybox>
                        </div>


                    </div>


                    <div className="galeria-abajo">
                        <div className="slide">
                            <Fancybox>
                                <Slider {...galeriaSlide3}>
                                    <div className="item">
                                        <a href="/images/interiores/galeria_8_slide_1_escritorio.png" data-fancybox="galeria-3" data-caption="Galeria 3">
                                            <div className="tablet">
                                                <img
                                                    src={"/images/interiores/galeria_8_slide_1_tablet.png"}
                                                    alt="comedor"
                                                    style={{ width: "598px", height: "399px" }}
                                                />
                                            </div>
                                            <div className="note">
                                                <img
                                                    src={"/images/interiores/galeria_8_slide_1_escritorio.png"}
                                                    alt="comedor"
                                                    style={{ width: "1294px", height: "936px" }}
                                                />
                                            </div>
                                        </a>
                                    </div>
                                    <div className="item">
                                        <a href="/images/interiores/galeria_8_slide_2_escritorio.png" data-fancybox="galeria-3" data-caption="Galeria 3">
                                            <div className="tablet">
                                                <img
                                                    src={"/images/interiores/galeria_8_slide_2_tablet.png"}
                                                    alt="baño"
                                                    style={{ width: "598px", height: "399px" }}
                                                />
                                            </div>
                                            <div className="note">
                                                <img
                                                    src={"/images/interiores/galeria_8_slide_2_escritorio.png"}
                                                    alt="baño"
                                                    style={{ width: "1294px", height: "936px" }}
                                                />
                                            </div>
                                        </a>
                                    </div>
                                    <div className="item">
                                        <a href="/images/interiores/galeria_8_slide_3_escritorio.png" data-fancybox="galeria-3" data-caption="Galeria 3">
                                            <div className="tablet">
                                                <img
                                                    src={"/images/interiores/galeria_8_slide_3_tablet.png"}
                                                    alt="dormitorio"
                                                    style={{ width: "598px", height: "936px" }}
                                                />
                                            </div>
                                            <div className="note">
                                                <img
                                                    src={"/images/interiores/galeria_8_slide_3_escritorio.png"}
                                                    alt="dormitorio"
                                                    style={{ width: "1294px", height: "936px" }}
                                                    width={1294}
                                                    height={936}
                                                />
                                            </div>
                                        </a>
                                    </div>
                                </Slider>
                            </Fancybox>
                        </div>
                    </div>
                </div>


            </section>
            <UbicacionCompoent />
        </div >
    )
}

export default Interiores